/* eslint-disable no-nested-ternary */
import MDTypography from "components/MDTypography";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function RemainingTime({ endDate }) {
  const loginUser = useSelector((state) => state.loginUser.loginUserState);
  const [days, setDays] = useState();
  const [hours, setHours] = useState();
  const [minutes, setMinutes] = useState();

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const interval = setInterval(() => {
      const then = moment.tz(endDate, loginUser.timezone);
      const now = moment.tz(undefined, loginUser.timezone);
      const countdown = moment.duration(then.diff(now));
      const daysValue = countdown.days();
      const hoursValue = countdown.hours();
      const minutesValue = countdown.minutes();
      setDays(daysValue >= 0 ? daysValue : 0);
      setHours(hoursValue >= 0 ? hoursValue : 0);
      setMinutes(minutesValue >= 0 ? minutesValue : 0);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <MDTypography>
      {days > 0 ? days : null} {days > 1 ? "Days, " : days === 1 ? "Day, " : null}
      {hours > 0 ? hours : null} {hours > 1 ? "Hours, " : hours === 1 ? "Hour, " : null}
      {minutes > 0 ? minutes : null} {minutes > 1 ? "Minutes" : minutes === 1 ? "Minute" : null}
      {!days && !hours && !minutes && "-"}
    </MDTypography>
  );
}

export default RemainingTime;
